import type { Post, PostType, VideoPostType } from '../../../../types'

export enum Usage {
  none = 'none',
  same = 'same',
  different = 'different',
}

export type WelcomePost = {
  postType: PostType
  title: string
  description?: string
  image?: string
  imageResourceId?: number
  videoThumbnail?: string | File
  videoType: VideoPostType
  video?: string | File
  videoUrl?: string
  imageType?: string
  status?: Post['statuses']['resources']
}

export enum FormFields {
  usage = 'usage',
  welcomePost = 'welcomePost',
  welcomePosts = 'welcomePosts',
}

export type FormValues = {
  [FormFields.usage]: Usage
  [FormFields.welcomePost]: WelcomePost
  [FormFields.welcomePosts]: Record<number, WelcomePost>
}
